<footer class="footer-component">
  <p class="footer-content pt-2">
    <small class="text-muted">
          Copyright © 2023 Axivise Technologies Pvt. Ltd. All rights reserved.
    </small>
    <small class="text-muted float-end">
      Version 1.0
    </small>
  </p>
</footer>